// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"97":"e3940368","283":"f8dcafba","478":"90ecd53f","790":"099c80b3","809":"90ea9472"}[chunkId] + ".chunk.js";
};